import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/custom.css";

import { ApolloClient, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";
import { split, HttpLink } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "apollo-link-error";
import { SubDirectory } from "./utils/defaults";
import SquarePayment from "./views/square";
import NotFound from "./views/NotFound";
import SquareVerify from "./views/squareVerify";
import AuthorizeNetA from "./views/authorizeneta";
import StripePayment from "./views/stripe";
import StripeVerify from "./views/stripeVerify";
import AuthorizeNetAVerify from "./views/authorizenetaVerify";
import BraintreePayment from "./views/braintree";
import BrainTreeVerify from "./views/braintreeVerify";
import PriorityVerify from "./views/priorityVerify";
import PriorityPayment from "./views/priority";
import BreezePayment from "./views/breeze";
import BreezePaymentSuccess from "./views/breeze_success";
import NMI from "./views/nmi";
import NMIVerify from "./views/nmiVeryify";
import NMI_B from "./views/nmi_b";
import NMI_BVerify from "./views/nmi_bVeryify";

// import { createUploadLink } from 'apollo-upload-client'

let BaseURL =
  process.env.REACT_APP_APIURL + ":" + process.env.REACT_APP_SERVERPORT;
let WebSocketURL, HttpURL;

if (process.env.REACT_APP_APIURL === "localhost") {
  WebSocketURL = "ws://" + BaseURL + "/subscriptions";
  HttpURL = "http://" + BaseURL + "/graphql";
} else {
  WebSocketURL = "wss://" + BaseURL + "/subscriptions";
  HttpURL = "https://" + BaseURL;
}

const wsLink = new WebSocketLink({
  uri: WebSocketURL,
  options: {
    reconnect: true,
  },
});

const httpLink = new HttpLink({
  uri: HttpURL,
  credentials: "include",
});

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink,
);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log("graphQLErrors", graphQLErrors);
  }
  if (networkError) {
    console.log("networkError", networkError);
  }
});

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  errorLink,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <Switch>
        <Route path={"/stripe"} render={() => <StripePayment />} />
        <Route path={"/priority"} render={() => <PriorityPayment />} />
        <Route path={"/authorizenet_a"} render={() => <AuthorizeNetA />} />
        <Route
          path={"/authorizenet_a-verify"}
          render={() => <AuthorizeNetAVerify />}
        />
        <Route path={"/square"} render={() => <SquarePayment />} />
        <Route path={"/braintree"} render={() => <BraintreePayment />} />
        <Route path={"/braintree-verify"} render={() => <BrainTreeVerify />} />
        <Route path={"/stripe-verify"} render={() => <StripeVerify />} />
        <Route path={"/priority-verify"} render={() => <PriorityVerify />} />
        <Route path={"/square-verify"} render={() => <SquareVerify />} />
        <Route path={"/breeze"} render={() => <BreezePayment />} />
        <Route path={"/nmi"} render={() => <NMI />} />
        <Route path={"/nmi-verify"} render={() => <NMIVerify />} />
        <Route path={"/nmi_b"} render={() => <NMI_B />} />
        <Route path={"/nmi_b-verify"} render={() => <NMI_BVerify />} />
        <Route
          path={"/breezesuccess"}
          render={() => <BreezePaymentSuccess />}
        />
        <Route path={"*"} render={() => <NotFound />} />
      </Switch>
    </BrowserRouter>
  </ApolloProvider>,
);
